import { z } from 'zod';
import { DecimalJSLikeSchema } from "../inputTypeSchemas/DecimalJsLikeSchema"
import { isValidDecimalInput } from "../inputTypeSchemas/isValidDecimalInput"

/////////////////////////////////////////
// TASK SCHEMA
/////////////////////////////////////////

export const TaskSchema = z.object({
  taskId: z.number().int(),
  cityId: z.number().int(),
  caseId: z.number().int(),
  dateTaskStart: z.coerce.date().nullable(),
  dateTaskDue: z.coerce.date(),
  details: z.string(),
  taskAssignedToId: z.number().int(),
  dateTaskDone: z.coerce.date(),
  numHours: z.union([z.number(),z.string(),DecimalJSLikeSchema,]).refine((v) => isValidDecimalInput(v), { message: "Field 'numHours' must be a Decimal. Location: ['Models', 'Task']",  }).nullable(),
  laborCost: z.union([z.number(),z.string(),DecimalJSLikeSchema,]).refine((v) => isValidDecimalInput(v), { message: "Field 'laborCost' must be a Decimal. Location: ['Models', 'Task']",  }).nullable(),
  taskStatus: z.string(),
})

export type Task = z.infer<typeof TaskSchema>

export default TaskSchema;
